<app-aggregated-amount-item name="UM 特設ページユーザー数"
  icon="./assets/universal_music.png"
  amount="{{ (specialUmhpPageUserView$ | async)?.units }}"
  unit="ページユーザー数"
  [rate]="(specialUmhpPageUserView$ | async)?.rate"
  link=""
  help="{{
    (selectedArtist$ | async).nameMain
  }}の UM 特設サイトページユーザー数です。ページユーザー数は選択期間内の合計数です。"
  [hasAmount]="(specialUmhpPageUserView$ | async)?.hasUnits"
  [loading]="loading$ | async"
  [dataCollections]="dataCollections$ | async"
  [dataCollectLoading]="dataCollectLoading$ | async"></app-aggregated-amount-item>